import { type MoveEvent, other, seamAttack } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const WRAP = '/art/wrap.svg';
const wrapped = (e: MoveEvent) => e.t === 'fx' && e.kind === 'wrap';

export const wrapUi: VariantUi = {
  heroImage: WRAP,
  peek: [{ image: '/art/bK.svg', threat: true }, {}, {}, {}, {}, {}, {}, {}, { image: '/art/wR.svg' }],

  twist(pos, you) {
    const k = pos.royals[pos.turn];
    if (k >= 0 && seamAttack(pos.board, k, other(pos.turn))) {
      const yours = you === null || you === pos.turn;
      return { text: yours ? 'Check from across the edge!' : 'Their king is in check from across the edge', alert: yours };
    }
    return { text: 'The a- and h-files are joined: watch both edges' };
  },

  eventSound(e) {
    return wrapped(e) ? 'warp' : null;
  },

  moveBadge(rec) {
    return rec.events.some(wrapped) ? { icon: WRAP, victim: rec.captured || undefined, title: 'Across the edge' } : null;
  },
};
